<style>
    .money{
      padding: 10px 0;
      background-color: white;
      height:150px;
      width:100%;
      border:1px solid #CCC;;
      border-radius:10px ;
      vertical-align: middle;
    }
    .moneyInfo-text {
      display:table-cell;
      vertical-align:middle;
      text-align: left;
    }
    .moneyInfo-img {
      display:table-cell;
      vertical-align:middle;
      text-align: right;
    }
    .moneyInfo {
      display:table;
      height:150px;
      margin:0px auto;

    }
    .rule{
      display:table-cell;
      vertical-align:bottom;
    }
</style>

<template>
<el-row>
<el-row :gutter="30" style="width:100%;height:150px;" :align="middle">
  <el-col :span="7">
  <div class="money" >
  <el-row :gutter="30" >
      <el-col :span="8" class="moneyInfo">
          <div class="moneyInfo-img">
            <img src="static/img/dollar.png" width="80" height="80"  />
          </div>
      </el-col>
      <el-col :span="16" class="moneyInfo">
        <div class="moneyInfo-text">
        <p>已结算收入累计（元）</p>
        <p style="font-size:2em">{{channelInfo.totalMoney}}</p>
        <p>结算卡片：{{channelInfo.bankAccount}}</p>
        </div>
      </el-col>
  </el-row>
  </div>
  </el-col>
  <el-col :span="13"  class="moneyInfo">
    <div  class="rule">
      <ul>
        <li  style="padding-bottom:10px;"><b>【费用结算规则】</b></li>
        <li>每年3月15日、6月15日、9月15日、12月15日出上季度账单，请在账单出来后进行核算和查看账单明细，确保账单准确无误！</br>车小花在收到发票验证后3个工作日内向贵方渠道指定账户支付相应金额。</li>
      </ul>
    </div>

  </el-col>

</el-row>
<el-row>
<el-dialog title="账单明细" :visible.sync="dialogTableVisible">
  <el-table :data="clueDetailData" v-loading.body="detailLoading">
    <el-table-column property="date" label="日期" width="150"></el-table-column>
    <el-table-column property="clueCount" label="线索量" width="200"></el-table-column>
    <el-table-column property="cluePrice" label="线索单价"></el-table-column>
    <el-table-column property="clueTotalPrice" label="线索收入"></el-table-column>
  </el-table>
</el-dialog>

<el-dialog :visible.sync="imgVisible" size="tiny">
  <img width="100%" :src="voucherImageUrl" alt>
</el-dialog>
  <el-table
    :data="setttlementData"
    v-loading.body="loading"
    border
    style="width: 100%">
    <el-table-column
      label="账单季度"
      width="auto">
      <template scope="scope">
        <el-icon name="time"></el-icon>
        <span style="margin-left: 10px">{{ scope.row.statementQuarter }}</span>
      </template>
    </el-table-column>

    <el-table-column
      label="账单金额"
      width="auto">
      <template scope="scope">

        <span style="margin-left: 10px">{{ scope.row.totalSettlementOfQuarter }}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="结算状态"
      width="auto">
      <template scope="scope">

        <span style="margin-left: 10px" v-if="scope.row.state==1">未结算</span>
        <span style="margin-left: 10px" v-else-if="scope.row.state==2">已结算</span>
      </template>
    </el-table-column>
    <el-table-column
      label="结算凭证"
      width="auto">
      <template scope="scope"  >
        <span v-for="item in scope.row.voucherArr"   style="">
          <img @click="handlePictureCardPreview(item)" style="margin-left:10px; width:90px;height:90px;display: inline;" :src="item" alt>
        </span>

      </template>
    </el-table-column>
    <el-table-column
      label="结算时间"
      width="auto">
      <template scope="scope">
        <span style="margin-left: 10px">{{ scope.row.statementTime|dateTimeFormat }}</span>
      </template>
    </el-table-column>
    <el-table-column label="操作" width="auto">
      <template scope="scope">
          <el-button
            size="small"
           @click="showDetail(scope.row.id)">查看账单明细</el-button>
      </template>
    </el-table-column>
  </el-table>

  <el-pagination
    class="row basic-margin"
    @current-change="loadList"
    :current-page.sync ="currentPage"
    layout="total, prev, pager, next"
    :page-count="20"
    :total="total">
  </el-pagination>

</el-row>
</el-row>
</template>

<script>
import SettlementModel from '../../framework/models/settlementModel'
import BasicPager from '../../mixins/BasicPager'
export default {
  name: 'channel-expense-statistics',
  extends: BasicPager,
  data: function () {
    return {
      channelId: 0,
      currentPage: 1,
      total: 50,
      loading: false,
      detailLoading: false,
      imgVisible: false,
      voucherImageUrl: '',
      channelHead: 'https://csz-test.oss-cn-hangzhou.aliyuncs.com/ClueDistribution/settlement/2017-07-27/1501136861385.jpg',
      clueDetailData: [{
        date: '2016-05-02',
        clueCount: 20,
        cluePrice: 10,
        clueTotalPrice: 200
      }],
      dialogTableVisible: false,
      setttlementData: [{}],
      channelInfo: {
        totalMoney: '5123,00',
        bankAccount: '62*******4848'

      }
    }
  },
  watch: {
    currentPage: function () {
      this.loadList()
    }
  },
  created: function () {
    let loginInfo = this.getLoginInfo()
    if (loginInfo.id) {
      this.channelId = loginInfo.id
      console.log(this.channelId)
    }
    this.loadChannelDetail()
    this.loadList()
  },
  methods: {
    handlePictureCardPreview (imageUrl) {
      this.voucherImageUrl = imageUrl
      this.imgVisible = true
    },
    showDetail (id) {
      this.dialogTableVisible = true
      let _this = this
      _this.detailLoading = true

      let params = {
        id: id
      }

      let listener = {
        onResponse: function () {
          _this.detailLoading = false
        },
        success: function (dataInfo) {
          _this.clueDetailData = dataInfo.data
        }
      }
      SettlementModel.findSettlementDetail(_this, params, listener)
    },
    loadList: function () {
      let _this = this

      _this.loading = true

      let params = {
        start: _this.currentPage,
        length: 10,
        channelId: _this.channelId
      }

      let listener = {
        onResponse: function () {
          _this.loading = false
        },
        success: function (dataInfo) {
          _this.setttlementData = dataInfo.data
          _this.total = dataInfo.recordsTotal
        }
      }
      SettlementModel.findSettlementRecord(_this, params, listener)
    },
    loadChannelDetail: function () {
      let _this = this
      let params = {
        channelId: _this.channelId
      }

      let listener = {
        onResponse: function () {

        },
        success: function (dataInfo) {
          _this.channelInfo = dataInfo.datas
        }
      }
      SettlementModel.loadChannelDetail(_this, params, listener)
    }
  }
}
</script>
